export default __webpack_public_path__ + "static/media/bars.6a53a1f0.svg";